import React from 'react';
import { Col, Row } from '../../lib/utils';
import { colors } from '../../lib/colors';
import { Body3Regular, CaptionRegular, CaptionLight } from '../../lib/font';
import { Ticket } from '@/features/groupTicket/types';

const CLASS_TYPE_LABEL: Record<string, string> = {
    GROUP: '그룹',
    PRIVATE_1ON2: '1:2',
    PRIVATE_1ON3: '1:3',
};

const GroupTicketCard = ({ ticket, onClick, isSelected }: { ticket: Ticket; onClick: () => void; isSelected?: boolean }) => {
    const expiryLabel =
        ticket.totalCount && ticket.periodDays ? '횟수+기간' :
        ticket.totalCount ? '횟수제' :
        ticket.periodDays ? '기간제' : '무제한';
    const classTypes = ticket.allowedClassTypes.map((t) => CLASS_TYPE_LABEL[t] || t).join(', ');

    return (
        <div
            onClick={onClick}
            style={{
                width: 270,
                height: 160,
                borderRadius: 12,
                padding: '20px 22px',
                cursor: 'pointer',
                background: ticket.isActive
                    ? 'linear-gradient(135deg, #10B981, #059669)'
                    : 'linear-gradient(135deg, #9CA3AF, #6B7280)',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                marginRight: 16,
                marginBottom: 16,
                transition: 'all 0.15s',
                outline: isSelected ? '3px solid #2563EB' : 'none',
                outlineOffset: -3,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
        >
            <Col>
                <Row style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <span style={{ fontSize: 16, fontWeight: 700 }}>{ticket.name}</span>
                    <span
                        style={{
                            fontSize: 11,
                            fontWeight: 600,
                            padding: '2px 8px',
                            borderRadius: 4,
                            backgroundColor: 'rgba(255,255,255,0.25)',
                        }}
                    >
                        수업용
                    </span>
                </Row>
                <span style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>
                    {classTypes}
                </span>
            </Col>

            <Col>
                <Row style={{ justifyContent: 'space-between', alignItems: 'flex-end' }}>
                    <Col>
                        <span style={{ fontSize: 12, opacity: 0.7 }}>{expiryLabel}</span>
                        <span style={{ fontSize: 18, fontWeight: 700 }}>
                            {ticket.totalCount}회
                            {ticket.periodDays ? ` / ${ticket.periodDays}일` : ''}
                        </span>
                    </Col>
                    <span style={{ fontSize: 15, fontWeight: 600 }}>
                        {ticket.price.toLocaleString()}원
                    </span>
                </Row>
            </Col>
        </div>
    );
};

export default GroupTicketCard;
